<div class="modal-header">
  <h4 class="modal-title synchpc-primary" id="modal-title">Edit User</h4>
  <i
    style="z-index: 1"
    class="bi bi-x-lg text-danger"
    color="warn"
    (click)="onClose()"
    title="Close"
  ></i>
</div>
<div class="modal-body pb-0 overflow-auto text-grey">
  <form
    name="editUserForm"
    [formGroup]="editUserForm"
    autocomplete="off"
    spellcheck="false"
  >
    <mat-form-field style="width: 32%; margin-right: 2%">
      <mat-label>Email</mat-label>
      <input
        matInput
        placeholder="Email"
        type="email"
        multiple
        formControlName="editUserEmail"
        title="edit one or multiple comma separated emails."
      />
      <mat-error
        *ngIf="
          editUserForm.get('editUserEmail').touched &&
          editUserForm.get('editUserEmail').errors
        "
        >Required</mat-error
      >
    </mat-form-field>
    <mat-form-field style="width: 32%; margin-right: 2%">
      <mat-label>Contact</mat-label>
      <input
        matInput
        maxlength="14"
        type="text"
        placeholder="Contact"
        formControlName="editUserContact"
      />
      <mat-error
        *ngIf="
          editUserForm.get('editUserContact').touched &&
          editUserForm.get('editUserContact').errors?.pattern
        "
        >Enter A Valid Contact Number.</mat-error
      >
    </mat-form-field>
    <mat-form-field style="width: 32%">
      <mat-label>First Name</mat-label>
      <input
        matInput
        placeholder="First Name"
        formControlName="editFirstName"
      />
      <mat-error
        *ngIf="
          editUserForm.get('editFirstName').touched &&
          editUserForm.get('editFirstName').errors?.required
        "
        >Enter A Valid Name.</mat-error
      >
    </mat-form-field>
    <mat-form-field style="width: 32%; margin-right: 2%">
      <mat-label>Last Name</mat-label>
      <input matInput placeholder="Last Name" formControlName="editLastName" />
      <mat-error
        *ngIf="
          editUserForm.get('editLastName').touched &&
          editUserForm.get('editLastName').errors?.required
        "
        >Enter A Valid Last Name</mat-error
      >
    </mat-form-field>
    <mat-form-field style="width: 32%; margin-right: 2%">
      <mat-label>Allocated cores</mat-label>
      <input
        matInput
        placeholder="Allocated Cores"
        formControlName="editAllocatedCoreQuota"
      />
      <button
        type="button"
        class="mat-icon-button"
        data-placement="right"
        matSuffix
        matTooltip="Enter '-1' for Unlimited Cores"
        matTooltipPosition="right"
        style="color: var(--s-primary-color) !important; border: none"
      >
        <mat-icon>info</mat-icon>
      </button>
      <mat-error *ngIf="editUserForm.get('editAllocatedCoreQuota').touched"
        >Enter Non-Zero Numbers or -1</mat-error
      >
    </mat-form-field>

    <mat-form-field *ngIf="isGlobalAdmin" style="width: 32%">
      <mat-label>Max Per Session Time in Hr</mat-label>
      <input
        matInput
        maxlength="2"
        type="text"
        placeholder="Max Per Session Time in Hr"
        formControlName="perSessionMaxTime"
      />
    </mat-form-field>

    <mat-form-field style="width: 32%; margin-right: 2%">
      <mat-label>Anyware User GUID</mat-label>
      <input
        matInput
        placeholder="Anyware User GUID"
        formControlName="editAnywareUserGuid"
      />
      <mat-error
        *ngIf="
          editUserForm.get('editAnywareUserGuid').touched &&
          editUserForm.get('editAnywareUserGuid').errors?.required
        "
        >Enter A Valid Name.</mat-error
      >
    </mat-form-field>

    <mat-form-field style="width: 32%; margin-right: 2%">
      <mat-label>Anyware User UPN</mat-label>
      <input
        matInput
        placeholder="Anyware User UPN"
        formControlName="editAnywareUserUpn"
      />
      <mat-error
        *ngIf="
          editUserForm.get('editAnywareUserUpn').touched &&
          editUserForm.get('editAnywareUserUpn').errors?.required
        "
        >Enter A Valid Name.</mat-error
      >
    </mat-form-field>

    <mat-form-field *ngIf="isGlobalAdmin" style="width: 30%; margin-bottom: 4%">
      <mat-label>Session Balance</mat-label>
      <input
        matInput
        maxlength="2"
        type="number"
        placeholder="Session Balance"
        formControlName="sessionBalance"
      />
    </mat-form-field>

    <mat-form-field
      *ngIf="allowChangeUserRole"
      appearance="fill"
      style="width: 32%; margin-right: 2%"
      title="Change Role to {{ roleToChange }}."
    >
      <mat-label>Change Role to {{ roleToChange }}</mat-label>
      <mat-select formControlName="userRoleChangeReaderGlobalAdmin">
        <mat-option value="true">True</mat-option>
        <mat-option value="false">False</mat-option>
      </mat-select>
    </mat-form-field>

    <h4 class="modal-title synchpc-primary" id="modal-title">Upload file</h4>
    <p>Select the RDP template to upload</p>
    <div
      class="alert alert-info"
      style="
        padding: 8px;
        margin-bottom: 10px;
        font-size: 12px;
        border-radius: 4px;
        background-color: #e7f3ff;
        border: 1px solid #b6d7ff;
      "
    >
      <i class="bi bi-info-circle" style="margin-right: 5px"></i>
      <strong>File Naming Guidelines:</strong> Please use simple filenames
      without multiple dots (e.g., use "myfile.rdp" instead of "my.file.rdp").
    </div>
    <div
      style="
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
      "
    >
      <mat-form-field appearance="fill" style="width: 60%">
        <mat-label>File Type</mat-label>
        <mat-select formControlName="fileTypeApp">
          <mat-option *ngFor="let type of fileTypes" [value]="type">
            {{ type.name }}
          </mat-option>
        </mat-select>
        <mat-hint>Please Select File Type Before Uploading</mat-hint>
      </mat-form-field>
      <input
        type="file"
        #chooseAppFile
        style="display: none"
        (change)="uploadFiles($event, 'userScriptFile')"
      />
      <button
        type="button"
        [disabled]="!editUserForm.get('fileTypeApp').value || isUploading"
        [ngStyle]="{
          cursor:
            !editUserForm.get('fileTypeApp').value || isUploading
              ? 'not-allowed'
              : 'pointer'
        }"
        title="Select and upload file"
        class="bi bi-cloud-arrow-up pull-right uploadBtn"
        (click)="chooseAppFile.click()"
      >
        {{ isUploading ? "Uploading..." : "Upload File" }}
      </button>
    </div>

    <!-- Upload Progress and Status -->
    <div *ngIf="uploadStatus !== 'none'" style="margin-top: 10px">
      <!-- Progress Bar -->
      <mat-progress-bar
        *ngIf="isUploading"
        mode="determinate"
        [value]="uploadProgress"
        style="margin-bottom: 10px"
      >
      </mat-progress-bar>

      <!-- Status Message -->
      <div
        [ngClass]="{
          'text-success': uploadStatus === 'success',
          'text-danger':
            uploadStatus === 'error' || uploadStatus === 'unauthorized',
          'text-warning': uploadStatus === 'exists',
          'text-info': uploadStatus === 'uploading'
        }"
        style="padding: 8px; border-radius: 4px; margin-bottom: 10px"
        [ngStyle]="{
          'background-color':
            uploadStatus === 'exists'
              ? '#fff3cd'
              : uploadStatus === 'success'
              ? '#d1edff'
              : uploadStatus === 'error' || uploadStatus === 'unauthorized'
              ? '#f8d7da'
              : 'transparent'
        }"
      >
        <i
          class="bi"
          [ngClass]="{
            'bi-check-circle-fill': uploadStatus === 'success',
            'bi-exclamation-triangle-fill':
              uploadStatus === 'error' || uploadStatus === 'unauthorized',
            'bi-info-circle-fill': uploadStatus === 'exists',
            'bi-cloud-upload': uploadStatus === 'uploading'
          }"
          style="margin-right: 8px"
        >
        </i>
        {{ uploadMessage }}
        <span *ngIf="isUploading"> ({{ uploadProgress }}%)</span>
      </div>

      <!-- Retry button for file exists error -->
      <div *ngIf="uploadStatus === 'exists'" style="margin-top: 5px">
        <small class="text-muted">
          <i class="bi bi-info-circle"></i>
          Tip: Rename your file or select a different file to proceed.
        </small>
      </div>
    </div>

    <!------------------------------------->
    <mat-tab-group *ngIf="isGlobalAdmin">
      <mat-tab label="Public key" class="mat-elevation-z4">
        <ng-container>
          <mat-form-field
            class="example-full-width"
            style="width: 100%"
            appearance="fill"
          >
            <mat-label>Public Key</mat-label>
            <textarea
              matInput
              formControlName="editPublicKey"
              rows="6"
              style="width: 98%; max-width: 98%; padding: 5px; resize: none"
            ></textarea>
          </mat-form-field>
        </ng-container>
      </mat-tab>
      <mat-tab label="User start command" class="mat-elevation-z4">
        <ng-container>
          <mat-form-field
            class="example-full-width"
            style="width: 100%"
            appearance="fill"
          >
            <mat-label>User start command.</mat-label>
            <textarea
              matInput
              formControlName="editUserCommand"
              rows="6"
              style="width: 98%; max-width: 98%; padding: 5px; resize: none"
              placeholder="Enter user init command which will be executed during job execution."
            ></textarea>
          </mat-form-field>
        </ng-container>
      </mat-tab>
      <mat-tab label="Additional Information" class="mat-elevation-z4">
        <ng-container>
          <mat-form-field
            class="example-full-width"
            style="width: 100%"
            appearance="fill"
          >
            <mat-label>Additional User Information.</mat-label>
            <textarea
              matInput
              formControlName="editUserAdditionalInfo"
              rows="6"
              style="width: 98%; max-width: 98%; padding: 5px; resize: none"
              placeholder=""
            ></textarea>
          </mat-form-field>
        </ng-container>
      </mat-tab>
    </mat-tab-group>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="onClose()">
    Close
  </button>
  <button type="submit" class="btn btn-primary" (click)="onSubmit()">
    Submit
  </button>
</div>
